import {JSX, splitProps} from 'solid-js';
import classNames from '@helpers/string/classNames';
import {getIconContent} from '@components/icon';
import {getIconMirrorClass} from '@/iconsReverse';

export type IconTsxProps = {
  icon: Icon;
} & JSX.HTMLAttributes<HTMLSpanElement>;

export const IconTsx = (inProps: IconTsxProps) => {
  const [props, rest] = splitProps(inProps, ['icon', 'class']);
  return (
    <span aria-hidden="true" class={classNames('tgico', getIconMirrorClass(props.icon), props.class)} {...rest}>
      {getIconContent(props.icon)}
    </span>
  );
};
